import React, {useState, useContext, useEffect} from "react";
import { useTranslation, Trans } from 'react-i18next';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {DataContext} from '../contexts/DataContext';
import {Divider} from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Tooltip from '@mui/material/Tooltip';
import AdmSelection from "./admSelection";
import SliderYear from "./sliderYear";
import StormsTreeView from "./stormsTreeView";
import CloseButton from "./closeButton";
import FloodsTreeView from "./floodsTreeView";
import CircularProgress from "@mui/material/CircularProgress";
import {markOnce} from "../utils/miscFunctions";

export default function SelectedFlood(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const {countryData, loadingCountries, failedCountries} = props;

    // the menu is greyed out until the flood data of a first country has arrived (the others follow, see FloodsTreeView)
    const menuReady = Object.keys(countryData).length > 0 || loadingCountries.length === 0
    useEffect(() => {
        if (menuReady) markOnce('app:primary-ready')
    }, [menuReady])

    const { t } = useTranslation();

    //const [currentStorms, setCurrentStorms] = useState([])
    //const [latestStorms, setLatestStorms] = useState([])
    //const [pastStorms, setPastStorms] = useState([])
    //const [pastStormsSeason, setPastStormsSeason] = useState([])
    const {
        storm,
        currentStorm,
        pastStorm,
        updatePastStorm,
        current_storm,
        updateStorm,
        selectedStorm,
        updateSelectedStorm,
        updateCurrentStorm,
        updateCurrent_Storm,
        latest_storms,
        updateLatestStorms,
        url_root,
        updateStormsToShow
    } = useContext(DataContext);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        //updateStormsToShow([]);
    };

    const handleChange = (event) => {
        updateStorm(event.target.value);
    };

/*    const handleSelectedStormSeason = (event) => {
        setAnchorEl(false)
        if (latestStorms.map(x => x.id).includes(event.target.value)) {
            updateSelectedStorm(latestStorms.filter((i) => i.id === event.target.value)[0]);
        } else if (currentStorms.map(x => x.id).includes(event.target.value)) {
            updateSelectedStorm(currentStorms.filter((i) => i.id === event.target.value)[0]);
        } else {
            updateSelectedStorm(pastStorms.filter((i) => i.id === event.target.value)[0]);
        }
    }*/

    return (
        <Box className={'button-flood-exploration'} sx={{ minWidth: 120, boxShadow: 20, marginLeft:2,}}>
            <Tooltip placement={'top'} title={t('buttons.floods.helper')}>
                <span>
                <Button
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    disabled={!menuReady}
                    endIcon={loadingCountries.length > 0 ? <CircularProgress size={14} color="inherit" /> : null}
                >
                    {/*                <Trans i18nKey='buttons.storms'>
                    Storms
                </Trans>*/}
                    {t('buttons.floods.title')}
                </Button>
                </span>
            </Tooltip>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <CloseButton handleClose={handleClose}/>
                <FloodsTreeView countryData={countryData} loadingCountries={loadingCountries} failedCountries={failedCountries}/>

            </Menu>



        </Box>
    );
}
